module.exports = __webpack_public_path__ + "img/secret_key_auth.58ed99c8.png";